module.exports = __webpack_public_path__ + "static/media/upload-id.a56c3ab3.png";